module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("3"), _c('br'), _vm._v("Bleak December")])])]), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Her father’s “no later than noon” call lit up Isobel’s cell closer to four. Something had come up, he said, which had essentially turned his quick Christmas Eve trip to the office into another full workday. So it wasn’t until after five that they were finally able to wrestle their way through traffic and into the mall. Amazingly, they managed to extract themselves from the mad bustle, bags in tow, appendages intact, by seven. They were even able to locate the sedan before the first semifrozen droplets of the weatherman’s projected “wintry mix” began to pepper the pavement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel stared out the passenger-side window as her father maneuvered the car through the congested parking lot. Slushy rain streaked the glass, turning the whole view mottled. Christmas lights blurred into glowing smudges, while the bright holiday window displays melded into shapeless meshes of color.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the sedan edged toward the main road, a sifting of white snow slowly began to replace the sleet. It collected on the windshield in fluffy specks between wiper-blade swipes, the downy flecks bringing Isobel’s thoughts back, yet again, to her dream.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“Awfully quiet over there,” Isobel’s dad said. “How about some music?”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t wait for an answer. Instead he flipped on the radio, and through a scratch of fuzz that made Isobel flinch, Bing Crosby’s voice broke, crooning about a white Christmas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They turned, emerging from the bottleneck squeeze to join with the steady flow of traffic. Rows of trees swished past on the left, clumps of wild mistletoe clinging to their barren branches like tangled knots in petrified hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite her father’s attempt to spark conversation, Isobel’s thoughts remained lost in a world that existed between here and forever. A world that still held "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the entire day, the brief flashes of Varen’s face, both torturous and comforting, had been the only thing she could concentrate on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dream itself still felt loose in her head, more distant than a childhood memory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More than anything, she remembered being close to Varen. She just couldn’t recall where they’d been or what he had said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And as the day had dragged on, she wondered if her subconscious could somehow be the culprit behind the repeated dreams, doing its best to provide her with the one thing—the one person—that it hurt too much to be without.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If this keeps up,” her dad said, putting on his turn signal, “we might just get one of those.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel stirred from her thoughts. “One of those what?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“A white Christmas, Iz,” he said, his eyes never leaving ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("the road. “What are you thinking so hard about over there, anyway?”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As they switched lanes, her dad offered a wave of thanks to the lady in the kid-packed SUV who had let them over. Isobel glanced down at her hands in her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh.” She summoned her best semblance of a smile. “Just thinking about . . . Nationals,” she lied, and touched the thin golden band on the ring finger of her right hand. She twisted the ring, turning it around and around. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NATIONAL CHAMPION")]), _vm._v(" it read in bold capital letters that framed a smooth, glinting, Trenton-blue gemstone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seems like you’ve been thinking about that an awful lot lately,” he said. “Or worrying about it, I should say. I mean, to the point where you’re dreaming that it didn’t happen.” He paused, looking away from the road to glance in her direction. Isobel knew he was waiting for her to speak, but she couldn’t think of what to say. She didn’t know what it was he wanted to hear. It was better, she thought, to remain silent and let him draw his own conclusions. At least it was easier to hide the truth that way.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“You know, Izzy,” he said, returning his attention to the road, “you were really great out there this year. I mean, better than ever. And I’m not just saying that. I have to admit, I was a little nervous when I saw Heywood do their routine, but you guys smoked them. You know that, don’t you? I mean . . . I can’t help but get this feeling that, for whatever reason, you keep asking yourself if you really deserved to win. It’s like you feel guilty about it, when I don’t think I’ve ever seen you ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("more focused. The squad was great, but you, Izzy, it’s like you were on another plane of existence. I mean, you were totally "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("zoned")]), _vm._v(". You should be proud of yourself.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am,” she said, giving the ring a final twist as the sedan rolled into their subdivision, past the triple-tiered fountain, which now stood as still and silent as a cemetery monument, collecting snow in its empty basins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel sensed her dad glancing her way again, so she looked up and squeezed out yet another false smile. She tried her best to hold the expression, even when he looked away, but keeping up the game was starting to take its toll.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the very least, she’d tried to make it seem like Nationals had mattered to her in the way it once had, before that day at school when she’d been paired to work with a certain jade-eyed goth boy named Varen Nethers. Before she’d ever known a single thing about him or the ominous subject he’d chosen for their English project—the man who was Edgar Allan Poe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Isobel was a bad actress. When it came down to it, there was only so much “I’m okay—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("really")]), _vm._v("” smiling she could muster when she wasn’t out on the floor cheering, when she didn’t have any choreography or chants to prop up the new cardboard-cutout version of herself. Without a distraction that took all her mind and body, it was just too hard to pretend that she wasn’t empty on the inside. Or that she didn’t know far more about what had happened on Halloween than what she had told her parents.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The events of that night came back to her in flashes. The Grim Facade. The dreamworld masquerade. The falling ash ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("and the woodlands. The sky ripped into shreds by bleeding strips of violet. And his eyes. Always those eyes. Again and again she saw the blackness overtake them. She watched it spiral out, consuming her reflection, leaving behind a stranger.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think Mom will like the locket?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” Isobel blinked. “Yeah,” she said, recovering quickly, realizing that he must have meant the gift he’d picked up that afternoon, the one the store clerk had had to retrieve from the special-orders case. “Of course she will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sedan slowed as it neared the stop sign just before their street. Isobel raised her thumb to her lips and bit down on her nail. “Hey, Dad,” she said, speaking around her thumbnail, “have you thought any more about, you know, us going up to take a look at U of M?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead of rolling through the stop sign the way he usually did, the car gave a sudden slight jerk as he pressed the brake. At the same moment, Isobel saw his lips flatten into a thin, tight line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have,” he said, his voice taking on that strained sternness she had grown more and more accustomed to during the past two months.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From Halloween on, as the weather had grown colder, so, it seemed, had her father’s temperament, his fuse snipped shorter than the days themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel had become so used to tiptoeing around him, filtering her words and monitoring her requests, that it was getting harder to remember a time when things hadn’t been so tense between them, so guarded.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("It made her wonder if he would ever forgive her for lying to him. For sneaking off.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For falling in love with the wrong boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And?” she prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighed. Loosening his grip on the wheel, he made the turn onto their street. “And I think it’s great that you’re thinking about college, Izzy, I do. But we don’t have to go look at a school right away, you know. You’re still only a junior. There’s plenty of time. We can even go this summer if you’re still thinking about Maryland. Dallas and Nationals set us back a bit in the way of travel funds, kiddo. I just don’t think it’s feasible right now. Besides, you don’t really want to travel in "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("January")]), _vm._v(", do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But,” Isobel started. She clutched the door handle tight, trying to keep herself in check. She couldn’t seem too eager. She couldn’t seem too desperate, or he would see straight through her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taking a breath, she began again. “Dad, Martin Luther King weekend is the only time we don’t have practice or a game. And this summer will be my last chance for cheer camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her dad turned the steering wheel again, pulling the sedan into the driveway. In the same motion, he reached up to his visor and pressed the remote for the garage door. Snow filtered down in large clumps now, creating a rushing screen between the grille of the car and the yawning mouth of the garage as it opened with a low, grinding noise. A gray shadow slid over them as the sedan rolled into the dimly lit space.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“There’s always spring break, Izzy. Maybe we can go for your birthday. That way we could spend a little time there. Maybe see the Inner Harbor. I hear they’ve got a great aquarium.” He put the car into park and sat back, both hands resting on the top of the steering wheel, arms rigid. “But you know, I’ve talked to your mother about it, and I can’t say she’s exactly thrilled with the idea of your going so far away for school.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because of what happened on Halloween.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately, Isobel regretted blurting these words. She pulled her hands into her lap, curling them into fists. Looking down again, she glared at the Nationals ring she had thought would solve the problem of her parents’ doubts and bit her bottom lip, waiting for the rebuff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her dad turned off the car, killing the Christmas music. He pulled the keys from the ignition and the cab light sprang on. Isobel stole a glance in his direction. In the stark light, his features looked harder than they had in the months before. The lines around his mouth seemed deeper than she remembered, and maybe that was because these days she did her best to avoid looking either of her parents directly in the eye. Not just because of the guilt that had come from the lying and the sneaking off, or from the boundless worry she had caused them both that night, but because she had grown to fear her own transparency, to fear how much of the truth they would see. Especially her dad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He waited until the car grew cold to answer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“Halloween is part of it,” he said, a hint of fogged breath ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("escaping his lips. “And you can’t blame her for that, Izzy. You can’t blame either of us.”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel felt her insides sink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned away from him and, releasing the catch on her seat belt, grabbed the door handle and slid out. Winter air closed in around her, causing her own breath to appear in small white puffs. She felt a surge of gratitude for the cold. It helped her regain her composure. It kept her from cracking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Grab the bags out of the back, would you, Iz?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel obeyed, acting on autopilot as she did her best to resume an air of nonchalance. She opened the rear passenger-side door and withdrew their shopping bags full of boxes and packages, Christmas presents wrapped hurriedly in bright paper by harried clerks behind bustling customer service counters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel shut the car door, not daring to say anything else about Maryland. What else "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("could")]), _vm._v(" she say? She knew better than to try and push the subject any further. She couldn’t risk it. If either of her parents so much as suspected that she had other reasons for wanting to go, reasons beyond looking at a university cheer squad, then the entire plan, if it could even be called a plan at this point, would unravel. Her somewhat wishy-washy status of house arrest, she had no doubt, would elevate to an all-out code-red lockdown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that thought, Isobel made a solemn oath to herself not to mention Maryland again. After tomorrow, after Christmas, she would need to cut her losses and start figuring out a way to get there on her own.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("A twisty sensation, like a python unwinding from a branch, unfurled through her gut. The thought of traveling to such a huge city alone sent a jolt of panic through her. Not to mention the fact that she would have to steal from her parents in order to afford a plane ticket or even bus fare. And then there was the added problem that she’d have to sneak out, and lie. Again.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But Baltimore was her last hope. Her "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("only")]), _vm._v(" hope. There, in a cemetery, during the early morning hours of January 19, Edgar Allan Poe’s birthday, a man could be observed every year visiting the poet’s grave. A man in a cloak and a hat. A man who hid his face behind a white scarf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A coward,")]), _vm._v(" Isobel thought, her hands tightening into fists around the shopping bag handles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Known the world over as the “Poe Toaster,” he had been appearing at Poe’s grave for decades. Materializing out of nowhere, he would place three red roses there and then vanish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only a single photograph of him existed. Taken sometime back in the nineties for "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Life")]), _vm._v(" magazine, the scratchy black-and-white print showed a night-vision image, pixelated and indefinite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Either luck or fate had caused the photo to fall into Isobel’s hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After grading her and Varen’s paper and project on Poe, Isobel’s English teacher, Mr. Swanson, had handed back the assignment with an article detailing the Poe Toaster’s rite. Also included in the article had been the infamous image.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("A shock had run through Isobel the moment she had set eyes on it. She could not have mistaken the kneeling man in the photograph. It was the same man who had once appeared to her in her dreams, calling himself “Reynolds.” The same man who had warned her from the beginning, who had fought by her side and had even saved her life.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the very end, though, he had lied to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel felt a stab of bitter coldness at the memory of how he had betrayed her, cruelly playing her own hope against her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before she discovered that he’d tricked her into thinking that, like her, Varen had returned safely to the real world, Reynolds had promised Isobel that the two of them would never meet again. But Isobel knew he would never count on her discovering his identity as the Poe Toaster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why would he, when he’d never counted on her doing anything but blindly playing along with his own plans?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her resolve deepening, Isobel headed for the kitchen door and shouldered her way in, her dad following close behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she crossed the threshold, the aroma of baked turkey and mashed potatoes rushed her, the rich scent accompanied by a wave of warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mom stood at the stove dressed in worn dark-wash jeans and an oversize gray sweatshirt. Stirring a saucepan of gravy with one hand, she held open a thin paperback novel in the other. Isobel recognized the book as one of the trashy thrillers she liked to read between her brick-thick classics.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Her mom turned her head when she heard the door, though it took a second longer for her eyes to part from the ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("page. At last she lowered the book, flashing Isobel one of her distracted “I’m still somewhere else” smiles.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Back already?” she asked. “That was quick for a Christmas Eve venture to the mall.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel pulled off her white knit hat. A loud growl rumbled through her stomach, even though she didn’t feel the gnawing hunger it implied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She set the bags down and peeled off her gloves. Shedding her coat, she hung it on one of the hooks behind the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the living room, she could hear the familiar sound of video-game music punctuated by the slashing twang of swords and the anguished cries of fallen undead. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Danny,")]), _vm._v(" she thought. Still in front of the TV. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Always")]), _vm._v(" in front of the TV.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel’s mom laid her book aside, open and facedown on the countertop to hold her place. “I started dinner late because I thought you two would be gone at least another half hour,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know me,” Isobel’s dad chimed in, shutting the door. He shed his coat and hung it next to Isobel’s. “Quick and simple. That’s the way we roll, right, Izzy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel shot him an incredulous stare. Had he really just said “roll”?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snatching up the bags again, Isobel headed for the archway that led out into the hall but stopped when she felt two sets of eyes boring into her back. She glanced over her shoulder to find her suspicions confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” she asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("On the stove, the saucepan of gravy started to burble and ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("slurp. Her mom, as though snapping from a trance, turned away and switched off the burner.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hands shoved into his pockets, her dad continued to stare at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She already knew what he must be thinking. He was probably wondering to himself if things would ever go back to being normal. If she would ever be the same again. If "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("they")]), _vm._v(" would ever be the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In turn, Isobel wondered how long it would take for him to realize the obvious answer to that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gave the bags a shake. “So I think I’ll go try to find a place to stash this stuff.” Without waiting for a response, she ducked into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” she heard him call after her. “Good thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Isobel made her way into the hallway, she thought she could hear her mother whispering, asking her father, “What happened?” and she knew he would cave and tell her that she’d brought up the Maryland trip. Again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel cringed. She switched the shopping bags to one hand and grabbed her scarf with the other, pulling the itchy woolen fabric free from her throat. Stalking down the hall, she passed the archway that led into the living room, where both the TV and the Christmas tree glowed with soft silvery light. Isobel stopped long enough to squint at the television screen, which displayed a spreadsheet of video-game statistics, weapon lists, and blinking vital signs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("That the game had been paused could have been an indication of only two things: Either her little brother had had to ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("pee so bad that he couldn’t hold it any longer, or he’d been abducted by aliens.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel snorted at the abandoned controller and empty spot in front of the TV, sure that "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("she")]), _vm._v(" had never been so epically lame at twelve years old.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reaching the end of the hallway, she rounded the banister to face the stairway and started with a yelp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danny, who had apparently "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" ascended to the mother ship, stood at the bottom of the stairs, his chubby arms open wide, blocking her path. While one hand clasped the banister post, he pressed the other flat to the opposite wall, creating a barricade with his body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Season’s greetings, sister,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel eyed her little brother. It always made her wary whenever he addressed her as anything other than the usual “cheer troll” or “nerf herder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tossed his head to one side to clear away the lengthening bangs of his dark mud-brown hair from his sharp blue eyes. A smirk pulled at one corner of his mouth, giving him an impish look. “Only to inform you of a recent transaction in which you were an integral element,” he said, pug nose thrust into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel felt a twitch in her left eye. “Danny, just spit it out and move already.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“If it makes it "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("easier")]), _vm._v(" for you to understand,” he said with a sigh, adopting a tone one of his computer screen characters might use with any nameless underling, “I shall hereafter ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("employ the usage of smaller words more digestible to your limited heathen mortal palate.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You drink milk straight out of the carton and you’re calling "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me")]), _vm._v(" a heathen? Danny, tell me what you want and then get out of my way. I’m not in the mood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine,” he said, his expression collapsing into a deadpan stare. “So you know that weird friend of yours Dad hates? Bracelets. Talks funny. Too much hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gwen?” Isobel asked, eyes narrowing. She knew her brother could hardly mean anyone else. Aside from being pretty much her only friend these days, Gwen Daniels had been Isobel’s one accomplice in sneaking out on Halloween night. And Isobel’s dad had never forgotten that it had been Gwen who had lied to him outright, telling him that she and Isobel would be going to a parent-supervised all-girl karaoke sleepover at her house—not meeting Varen at an underground goth party.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s up in your room,” Danny said, and jerked his head toward the stretch of stairs behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel’s eyes flew wide. “Gwen’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("here")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gave me ten bucks to let her in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“What?”")]), _vm._v(" Isobel glanced up to where her door stood slightly ajar. Inside, a long shadow drifted across, momentarily blocking the light coming from within. She mounted the stairs, but Danny backpedaled in front of her, snapping his arms wide again. She halted, shooting him an icy glare of warning.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("“Ten bucks to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("let her in")]), _vm._v(",” he said. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“But,”")]), _vm._v(" he added, finger lifted, eyebrows rising to vanish beneath his mop of hair, “you ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("and I both know that such a nominal fee hardly covers my silence.” With that, he held out one chubby hand, palm up.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel gaped at her brother. “I’m not paying you!” she nearly shouted, and swatted his hand aside. She hurtled forward, shouldering past him, shopping bags in tow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To her surprise, Danny fell to one side, where he lounged against the wall, arms folded. “Think Dad won’t ground you for the rest of Christmas break?” he called after her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel halted midway up the stairs. She turned to glare back at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He beamed at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel imagined how good it would feel to reach out and snatch free a patch of his mussed hair. Growling, she slammed the bags down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t so much that she feared being grounded. Especially when she couldn’t be certain that she’d ever officially been "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("un")]), _vm._v("grounded. Or, for that matter, if she ever would be. But she didn’t want her mom or dad finding out about Gwen all the same. Not when Gwen was the one person besides herself who knew what had "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("really")]), _vm._v(" happened Halloween night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had been there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen had told Isobel that she’d known it was all real. And contrary to what everyone else believed, including the police, Gwen knew that Varen had not simply run away.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Isobel yanked her purse from her shoulder and rifled through the middle pocket. “You’re such a freaking snotmonger,” she snarled. Locating a ten, the last of her Christmas allowance, she crumpled the bill and flung it at him. It bounced ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("off his shoulder and landed on the stairs. Danny, taking on an air of reserved dignity, bent to retrieve the money. He smoothed the crumpled paper by rubbing it back and forth on the banister. Next, he held the bill up to the light as though checking for authenticity.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally he pocketed the money and, smiling, made a show of gesturing toward the stairs, his arm sweeping out Vanna White–style. “Your party awaits you up the steps and in the room to the left. As you make your way up, please remember to keep all hands, arms, tentacles, pincers, and mandibles inside the railings at all times and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just so you know,” Isobel snapped, all but spitting her words over her shoulder as she hauled up the bags again and climbed to the top of the landing, “I muted the TV and took your stupid game off pause.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danny dropped the scam act like a hot plate. He scampered down the stairs and bolted for the living room, belly wobbling, socked feet thundering. Isobel could practically "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hear")]), _vm._v(" him dive-bomb into his usual spot in front of the television, a swatch of beige carpeting that she could swear was taking on the contours of his butt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Muttering, she trudged to her bedroom door, which was cracked an inch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The knife-blade slice of frost-colored light that streamed out into the hallway flickered suddenly, as though someone inside had darted past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gwen?” she whispered. Placing a hand flat against the door, she pushed her way in.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 78
// module chunks = 0